import { Injectable } from '@angular/core';
import { ITabTemplate } from './i-tab-template';


@Injectable({
  providedIn: 'root'
})
export class TabTemplateCacheService {

  private tabTemplates: ITabTemplate[] = [];

  loaded = false;

  constructor() { }

  getTemplateByName(templateName) {
    return this.tabTemplates.find(t => t.name === templateName);
  }

  clearTemplates() {
    this.tabTemplates = [];
  }

  storeTemplate(template) {
    this.tabTemplates.push(template);
  }

  getCachedTemplates() {
    return this.tabTemplates;
  }

}
